module.exports = __webpack_public_path__ + "static/img/join2.450cabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/join2.png
// module id = 7eNf
// module chunks = 24